<template>
  <div class="bu10-container">
    <sensorView :sensorList="sensorList" :realDataObj="realDataObj" />
  </div>
</template>

<script>
import sensorView from './components/sensor-list.vue';

import { getBu10LastDataServer } from '@/api/devices';
import { isEmpty } from '@/utils/is';

let detectResDict = {
  0: '阴性',
  1: '阳性',
  2: '无效'
};

export default {
  // BU-10设备
  name: 'BU10-container',
  components: {
    sensorView
  },
  computed: {
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    }
  },
  sockets: {
    '/socket/detect/detail'(data) {
      if (isEmpty(data)) return;
      this.setRealData(data);
    }
  },

  data() {
    return {
      disableNotice: true,
      sensorList: [
        {
          name: '检测序号',
          prop: 'testIndex',
          unitName: ''
        },
        {
          name: '检测类型',
          prop: 'showDetectType',
          unitName: ''
        },
        {
          name: '检测结果',
          prop: 'showDetectResult',
          unitName: ''
        },
        {
          name: '检测时间',
          prop: 'testTime',
          unitName: ''
        }
      ],
      realDataObj: {
        testTime: '',
        testIndex: '',
        detectType: '',
        detectResult: 0
      }
    };
  },
  mounted() {
    this.loadRecentlyDataFunc();
  },

  methods: {
    loadRecentlyDataFunc() {
      getBu10LastDataServer(this.sn).then(res => {
        const { data } = res;

        if (isEmpty(data)) return;

        this.setRealData(data);
      });
    },

    setRealData(data) {
      data.showDetectType = data.name;
      data.showDetectResult = detectResDict[data.detectResult];
      Object.assign(this.realDataObj, data);
    }
  }
};
</script>

<style lang="scss">
.bu10-container {
  padding: 20px;
  box-sizing: border-box;
  .sensor-list {
    .sensor-list-item {
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
    }
  }
  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
